import {
  postRiskWorkspace,
  fetchRiskWorkspaces,
  fetchRiskWorkspaceById,
  deleteRiskWorkspace,
  updateRiskWorkspace,
} from '@app/services/riskService'
import type { NewRiskWorkspace, RiskWorkspace } from '@app/types'
import { atom } from 'jotai'
import { atomWithMutation, atomWithQuery, queryClientAtom } from 'jotai-tanstack-query'
import { clientNameAtom } from './clientsAtom'

export const riskWorkspaceModalOpenAtom = atom<boolean>(false)
export const riskWorkspaceModalAnchorAtom = atom<HTMLElement | null>(null)

export const riskAvailableWorkspacesAtom = atomWithQuery<RiskWorkspace[]>((get) => {
  const clientName = get(clientNameAtom)
  return {
    queryKey: ['riskAvailableWorkspaces', clientName],
    queryFn: async () => {
      if (!clientName) return []
      return fetchRiskWorkspaces(clientName)
    },
    enabled: !!clientName,
  }
})

export const riskCreateWorkspaceAtom = atomWithMutation((get) => ({
  mutationKey: ['riskCreateWorkspace'],
  mutationFn: async (newWorkspace: NewRiskWorkspace) => {
    const resultWithId = await postRiskWorkspace(newWorkspace)
    const createdWorkspace = await fetchRiskWorkspaceById(resultWithId.id)
    return createdWorkspace
  },
  onSuccess: () => {
    const queryClient = get(queryClientAtom)
    queryClient.invalidateQueries({ queryKey: ['riskAvailableWorkspaces'] })
  },
}))

export const riskUpdateWorkspaceAtom = atomWithMutation((get) => ({
  mutationKey: ['riskUpdateWorkspace'],
  mutationFn: async ({
    id,
    updatedWorkspace,
  }: {
    id: string
    updatedWorkspace: NewRiskWorkspace
  }) => updateRiskWorkspace(id, updatedWorkspace),
  onSuccess: () => {
    const queryClient = get(queryClientAtom)
    queryClient.invalidateQueries({ queryKey: ['riskAvailableWorkspaces'] })
  },
}))

export const riskDeleteWorkspaceAtom = atomWithMutation((get) => ({
  mutationKey: ['riskDeleteWorkspace'],
  mutationFn: async (id: string) => deleteRiskWorkspace(id),
  onSuccess: () => {
    const queryClient = get(queryClientAtom)
    queryClient.invalidateQueries({ queryKey: ['riskAvailableWorkspaces'] })
  },
}))

riskCreateWorkspaceAtom.debugLabel = 'riskCreateWorkspaceAtom'
riskUpdateWorkspaceAtom.debugLabel = 'riskUpdateWorkspaceAtom'
riskDeleteWorkspaceAtom.debugLabel = 'riskDeleteWorkspaceAtom'
